import { InputText } from "primereact/inputtext";
import styles from "./search-input.module.scss";
import { ChangeEvent, ReactNode, SyntheticEvent, useEffect, useRef, useState } from "react";
import classNames from "classnames";

export interface SearchInputProps {
  searchIcon?: ReactNode;
  clearIcon?: ReactNode;
  searchTerm?: string;
  className?: string;
  placeholder?: string;
  onSearch: (searchTerm: string) => void;
}

export function SearchInput({
  searchIcon,
  clearIcon,
  searchTerm = "",
  className,
  placeholder,
  onSearch,
}: SearchInputProps) {
  const [searchPhrase, setsearchPhrase] = useState(searchTerm);
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setsearchPhrase(value);

    // Debounce: fire onSearch 400ms after the user stops typing
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      onSearch(value);
    }, 400);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
      onSearch(searchPhrase);
    }
  };

  const clearSearchPhrase = (_: SyntheticEvent) => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    setsearchPhrase("");
    onSearch("");
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
  }, []);

  return (
    <div className={`w-full`}>
      <span className="p-input-icon-left w-full flex items-center">
        {!!searchIcon ? <span className="absolute ml-3">{searchIcon}</span> : null}
        <InputText
          value={searchPhrase}
          placeholder={placeholder}
          onChange={handleSearch}
          onKeyUp={handleKeyPress}
          className={classNames(className, 'pl-8')}
        />
        {searchPhrase && (
          <span
            className={classNames(styles["right-icon"], "cursor-pointer")}
            onClick={clearSearchPhrase}
          >
            {clearIcon}
          </span>
        )}
      </span>
    </div>
  );
}

export default SearchInput;
